const style = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(0,0,0,0.5)',
    zIndex: 98,
  },
  sidebarContainer: {
    width: "300px",
    height: "100vh",
    background: "#1e212b",
    position: "fixed",
    top: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    boxShadow: "5px 0px 30px rgba(0,0,0,0.2)",
    zIndex: 99,
    transform: "translateX(0)",
    transition: "transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  },
  sidebarContainerClosed: {
    width: "300px",
    height: "100vh",
    background: "#1e212b",
    position: "fixed",
    top: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    zIndex: 99,
    transform: "translateX(-100%)",
    transition: "transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  },
  header: {
    padding: "20px 25px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #2a2f3b",
    flexShrink: 0,
  },
  companyLogoImage: {
    height: "45px",
    width: "auto",
    objectFit: "contain",
  },
  closeButton: {
    background: 'none',
    border: 'none',
    color: '#aeb9c4',
    cursor: 'pointer',
    padding: '5px',
    display: 'flex',
  },
  routesBox: {
    flexGrow: 1,
    padding: "15px 0",
    overflowY: "auto",
  },
  routeBox: {
    display: "flex",
    alignItems: "center",
    padding: "15px 25px",
    gap: "20px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    borderLeft: "4px solid transparent",
  },
  activeRouteBox: {
    background: "rgba(78, 207, 120, 0.1)",
    borderLeft: "4px solid #4ecf78",
  },
  routeIcon: {
    color: "#aeb9c4",
    display: "flex",
    alignItems: "center",
  },
  routeTitle: {
    fontSize: "16px",
    fontWeight: 500,
    color: "#aeb9c4",
  },
  footer: {
    padding: "20px 25px",
    borderTop: "1px solid #2a2f3b",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexShrink: 0,
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
  },
  userName: {
    color: "#FFF",
    fontWeight: 600,
    fontSize: "16px",
  },
  userRole: {
    color: "#aeb9c4",
    fontSize: "14px",
  },
  logoutButton: {
    background: "#2a2f3b",
    border: "1px solid #3c4257",
    color: "#ff5b5b",
    width: "45px",
    height: "45px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
};

export default style;